import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

import { AcademicYearModule } from './academic-year.module';

@Injectable({
  providedIn: 'root'
})
export class AcademicYearService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
    };

    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }


    getService(): Observable<AcademicYearModule[]> {
        return this.http.get<AcademicYearModule[]>(environment.apiURL + 'Main/MNAcademicYear/');
    }
}
